import { useQuery } from "@tanstack/react-query";
import { getTribes } from "../api/api";
import { useSelector } from "react-redux";
import { MAX_TRIBE_USERS } from "../helpers/constants";
import { Tribe, TribeUser } from "../types/tribes.types";

export const useAvailableTribe = (event_id: string) => {
  const { user } = useSelector((state: any) => state.user);

  return useQuery({
    queryKey: ["availableTribe", event_id],
    queryFn: async () => {
      const response = await getTribes({
        event_id,
        search_query: "",
        page: 1,
        limit: 10,
        sortBy: "createdAt",
        order: -1,
      });

      if (response.statusCode !== 200) {
        throw new Error("Failed to fetch tribes");
      }

      const tribes = response.data.docs as Tribe[];

      const availableTribe = tribes
        .sort((a, b) => {
          const aCount = a.tribeUsers?.length ?? 0;
          const bCount = b.tribeUsers?.length ?? 0;
          return bCount - aCount;
        })
        .find((tribe) => {
          const memberCount = tribe.tribeUsers?.length ?? 0;
          const isUserMember = tribe.tribeUsers?.some(
            (tu: TribeUser) => tu.user_id === user._id
          );
          return memberCount < MAX_TRIBE_USERS && !isUserMember;
        });

      return availableTribe || null;
    },
    staleTime: 5000,
  });
};
